var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "typeFormBox" },
    [
      _c("PublicTitle", { attrs: { num: 1, text: "基本信息" } }),
      _vm._v(" "),
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-col": _vm.labelCol,
            "wrapper-col": _vm.wrapperCol
          }
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.spinning } },
            [
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseLogo",
                  attrs: { label: "上传logo", prop: "enterpriseLogo" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "small-card" },
                    [
                      _c(
                        "a-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            name: "file",
                            "list-type": "picture-card",
                            "show-upload-list": false,
                            data: _vm.uploadData,
                            action: _vm.action,
                            "before-upload": _vm.beforeUpload,
                            disabled: _vm.formDisabled
                          },
                          on: { change: _vm.headImageChange }
                        },
                        [
                          _vm.form.enterpriseLogo
                            ? _c("img", {
                                staticClass: "realImg",
                                attrs: {
                                  src: _vm.form.enterpriseLogo,
                                  alt: "logo"
                                }
                              })
                            : _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "uploadImgBox headImageDefault"
                                  },
                                  [
                                    _vm.headImageLoading
                                      ? _c("a-icon", {
                                          attrs: { type: "loading" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "administratorsName",
                  attrs: { label: "负责人姓名", prop: "administratorsName" }
                },
                [
                  _c("a-input", {
                    attrs: {
                      disabled: _vm.formDisabled,
                      placeholder: "请输入您的名字",
                      maxLength: "30"
                    },
                    on: {
                      blur: function() {
                        _vm.$refs.administratorsName.onFieldBlur()
                      }
                    },
                    model: {
                      value: _vm.form.administratorsName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "administratorsName", $$v)
                      },
                      expression: "form.administratorsName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "administratorsPhone",
                  attrs: { label: "联系方式", prop: "administratorsPhone" }
                },
                [
                  _c("a-input", {
                    attrs: {
                      disabled: "",
                      placeholder: "请输入联系方式",
                      type: "number",
                      maxLength: "15"
                    },
                    on: {
                      blur: function() {
                        _vm.$refs.administratorsPhone.onFieldBlur()
                      }
                    },
                    model: {
                      value: _vm.form.administratorsPhone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "administratorsPhone", $$v)
                      },
                      expression: "form.administratorsPhone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("PublicTitle", {
            attrs: { num: 2, text: "主体信息", border: true }
          }),
          _vm._v(" "),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.spinning } },
            [
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseTypeId",
                  attrs: { label: "组织类型", prop: "enterpriseTypeId" }
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "请选择组织类型",
                        disabled: _vm.formDisabled
                      },
                      model: {
                        value: _vm.form.enterpriseTypeId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "enterpriseTypeId", $$v)
                        },
                        expression: "form.enterpriseTypeId"
                      }
                    },
                    _vm._l(_vm.listData, function(item) {
                      return _c(
                        "a-select-option",
                        { key: item.id, attrs: { value: item.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.title) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("MiniIntroText", [
                    _vm._v("\n          如果无特定类型请选择其它\n        ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseName",
                  attrs: { label: "组织名称", prop: "enterpriseName" }
                },
                [
                  _c("a-input", {
                    attrs: {
                      disabled: _vm.formDisabled,
                      placeholder: "请输入组织名称",
                      maxLength: "30"
                    },
                    on: {
                      blur: function() {
                        _vm.$refs.enterpriseName.onFieldBlur()
                      }
                    },
                    model: {
                      value: _vm.form.enterpriseName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "enterpriseName", $$v)
                      },
                      expression: "form.enterpriseName"
                    }
                  }),
                  _vm._v(" "),
                  _c("MiniIntroText", [
                    _vm._v(
                      "\n          需与当地政府颁发的商业许可证书或企业注册证上企业名称完全一致,信息审核成功企业名称不可修改\n        "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseCode",
                  attrs: { label: "社会信用代码", prop: "enterpriseCode" }
                },
                [
                  _c("a-input", {
                    attrs: {
                      disabled: _vm.formDisabled,
                      placeholder: "请输入社会信用代码",
                      maxLength: "18"
                    },
                    on: {
                      blur: function() {
                        _vm.$refs.enterpriseCode.onFieldBlur()
                      }
                    },
                    model: {
                      value: _vm.form.enterpriseCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "enterpriseCode", $$v)
                      },
                      expression: "form.enterpriseCode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseRegionCode",
                  attrs: { label: "注册地址", prop: "enterpriseRegionCode" }
                },
                [
                  _c("el-cascader", {
                    ref: "cascader",
                    staticStyle: { width: "100%" },
                    attrs: {
                      size: "small",
                      disabled: _vm.formDisabled,
                      props: _vm.props,
                      "expand-trigger": "click",
                      "show-search": { filter: _vm.filter },
                      placeholder: _vm.form.enterpriseRegionCode
                        ? _vm.form.enterpriseRegion
                        : "请选择注册地址"
                    },
                    on: { change: _vm.onChange },
                    model: {
                      value: _vm.form.enterpriseRegionCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "enterpriseRegionCode", $$v)
                      },
                      expression: "form.enterpriseRegionCode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseAdress",
                  attrs: { label: "详细地址", prop: "enterpriseAdress" }
                },
                [
                  _c("a-textarea", {
                    attrs: {
                      disabled: _vm.formDisabled,
                      placeholder: "请输入详细地址",
                      maxLength: "50",
                      "auto-size": { minRows: 5, maxRows: 5 }
                    },
                    on: {
                      blur: function() {
                        _vm.$refs.enterpriseAdress.onFieldBlur()
                      }
                    },
                    model: {
                      value: _vm.form.enterpriseAdress,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "enterpriseAdress", $$v)
                      },
                      expression: "form.enterpriseAdress"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseStartTime",
                  attrs: { label: "营业期限", prop: "enterpriseStartTime" }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.formDisabled },
                      on: { change: _vm.clearDate },
                      model: {
                        value: _vm.form.enterpriseIsLongTerm,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "enterpriseIsLongTerm", $$v)
                        },
                        expression: "form.enterpriseIsLongTerm"
                      }
                    },
                    [_vm._v("长期")]
                  ),
                  _vm._v(" "),
                  _vm.form.enterpriseIsLongTerm == false
                    ? _c("a-range-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: _vm.formDisabled,
                          value: _vm.form.enterpriseStartTime
                            ? [
                                _vm.moment(_vm.form.enterpriseStartTime),
                                _vm.moment(_vm.form.enterpriseEndTime)
                              ]
                            : [],
                          separator: "至",
                          format: _vm.dateFormat,
                          valueFormat: "YYYY-MM-DD",
                          placeholder: ["开始日期", "结束日期"]
                        },
                        on: { change: _vm.dateChange }
                      })
                    : _c(
                        "div",
                        [
                          _c("a-date-picker", {
                            attrs: {
                              format: _vm.dateFormat,
                              disabled: _vm.formDisabled,
                              valueFormat: "YYYY-MM-DD",
                              placeholder: ["开始日期"],
                              value: _vm.form.enterpriseStartTime
                            },
                            on: { change: _vm.dateChange }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c("MiniIntroText", [
                    _vm._v(
                      "\n          请填写营业执照上营业期限,注意参照示例中的格式,结束时间需大于开始时间,有效期必须大于60天，如果为长期，请勾选长期\n        "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseLicense",
                  attrs: { label: "营业执照", prop: "enterpriseLicense" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "big-card" },
                    [
                      _c(
                        "a-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            disabled: _vm.formDisabled,
                            name: "file",
                            "list-type": "picture-card",
                            "show-upload-list": false,
                            data: _vm.uploadData,
                            action: _vm.action,
                            "before-upload": _vm.beforeUpload
                          },
                          on: { change: _vm.businessLicenseChange }
                        },
                        [
                          _vm.form.enterpriseLicense
                            ? _c("img", {
                                staticClass: "realImg",
                                attrs: {
                                  src: _vm.form.enterpriseLicense,
                                  alt: "营业执照"
                                }
                              })
                            : _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "uploadImgBox businessLicenseImg"
                                  },
                                  [
                                    _vm.businessLicenseLoading
                                      ? _c("a-icon", {
                                          attrs: { type: "loading" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("MiniIntroText", { staticStyle: { width: "280px" } }, [
                    _vm._v(
                      "\n          仅支持在有效期内的中国大陆工商局或市场监督管理局颁发的工商营业执照。格式要求：原证照片、扫描件或者\n          复印件加盖企业公章后的扫描\n        "
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("PublicTitle", {
            attrs: { num: 3, text: "法人信息", border: true }
          }),
          _vm._v(" "),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.spinning } },
            [
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseOperator",
                  attrs: { label: "法人姓名", prop: "enterpriseOperator" }
                },
                [
                  _c("a-input", {
                    attrs: {
                      disabled: _vm.formDisabled,
                      placeholder: "请输入法人姓名",
                      maxLength: "30"
                    },
                    on: {
                      blur: function() {
                        _vm.$refs.enterpriseOperator.onFieldBlur()
                      }
                    },
                    model: {
                      value: _vm.form.enterpriseOperator,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "enterpriseOperator", $$v)
                      },
                      expression: "form.enterpriseOperator"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseIdCard",
                  attrs: { label: "身份证号码", prop: "enterpriseIdCard" }
                },
                [
                  _c("a-input", {
                    attrs: {
                      disabled: _vm.formDisabled,
                      placeholder: "请输入身份证号码",
                      maxLength: "18"
                    },
                    on: {
                      blur: function() {
                        _vm.$refs.enterpriseIdCard.onFieldBlur()
                      }
                    },
                    model: {
                      value: _vm.form.enterpriseIdCard,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "enterpriseIdCard", $$v)
                      },
                      expression: "form.enterpriseIdCard"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseCardStartTime",
                  attrs: {
                    label: "身份证有效期",
                    prop: "enterpriseCardStartTime"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.formDisabled },
                      on: { change: _vm.clearDate2 },
                      model: {
                        value: _vm.form.enterpriseCardIsLongTerm,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "enterpriseCardIsLongTerm", $$v)
                        },
                        expression: "form.enterpriseCardIsLongTerm"
                      }
                    },
                    [_vm._v("长期")]
                  ),
                  _vm._v(" "),
                  _vm.form.enterpriseCardIsLongTerm == false
                    ? _c("a-range-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: _vm.formDisabled,
                          value: _vm.form.enterpriseCardStartTime
                            ? [
                                _vm.moment(_vm.form.enterpriseCardStartTime),
                                _vm.moment(_vm.form.enterpriseCardEndTime)
                              ]
                            : [],
                          separator: "至",
                          format: _vm.dateFormat,
                          valueFormat: "YYYY-MM-DD",
                          placeholder: ["开始日期", "结束日期"]
                        },
                        on: { change: _vm.dateChange_card }
                      })
                    : _c(
                        "div",
                        [
                          _c("a-date-picker", {
                            attrs: {
                              format: _vm.dateFormat,
                              disabled: _vm.formDisabled,
                              valueFormat: "YYYY-MM-DD",
                              placeholder: ["开始日期"],
                              value: _vm.form.enterpriseCardStartTime
                            },
                            on: { change: _vm.dateChange_card }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c("MiniIntroText", [
                    _vm._v(
                      " 结束时间要大于开始时间5年以上，如果为长期，请勾选长期 "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "enterpriseCardPositive",
                  staticClass: "enterpriseCardPositive",
                  attrs: { label: "证件照片", prop: "enterpriseCardPositive" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "big-card" },
                    [
                      _c(
                        "a-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            disabled: _vm.formDisabled,
                            name: "file",
                            "list-type": "picture-card",
                            "show-upload-list": false,
                            data: _vm.uploadData2,
                            action: _vm.action,
                            "before-upload": _vm.beforeUpload
                          },
                          on: { change: _vm.idCardImgFrontChange }
                        },
                        [
                          _vm.form.enterpriseCardPositive
                            ? _c("img", {
                                staticClass: "realImg",
                                attrs: {
                                  src: _vm.form.enterpriseCardPositive,
                                  alt: "证件照正面2"
                                }
                              })
                            : _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "uploadImgBox idCardImgFront"
                                  },
                                  [
                                    _vm.idCardImgFrontLoading
                                      ? _c("a-icon", {
                                          attrs: { type: "loading" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            disabled: _vm.formDisabled,
                            name: "file",
                            "list-type": "picture-card",
                            "show-upload-list": false,
                            data: _vm.uploadData2,
                            action: _vm.action,
                            "before-upload": _vm.beforeUpload
                          },
                          on: { change: _vm.idCardImgBcakChange }
                        },
                        [
                          _vm.form.enterpriseCardSide
                            ? _c("img", {
                                staticClass: "realImg",
                                attrs: {
                                  src: _vm.form.enterpriseCardSide,
                                  alt: "证件照背面"
                                }
                              })
                            : _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "uploadImgBox idCardImgBack" },
                                  [
                                    _vm.idCardImgBackLoading
                                      ? _c("a-icon", {
                                          attrs: { type: "loading" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("PublicTitle", {
                attrs: { num: 4, text: "推广商", border: true }
              }),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  ref: "promoter",
                  attrs: { label: "推广商", prop: "promoter" }
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "请选择推广商",
                        "default-value": _vm.form.promoter,
                        disabled: _vm.formDisabled
                      },
                      model: {
                        value: _vm.form.promoter,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "promoter", $$v)
                        },
                        expression: "form.promoter"
                      }
                    },
                    _vm._l(_vm.promoterData, function(item, index) {
                      return _c(
                        "a-select-option",
                        { key: index, attrs: { value: item } },
                        [
                          _vm._v(
                            "\n            " + _vm._s(item) + "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                { attrs: { "wrapper-col": { span: 24 } } },
                [
                  _c(
                    "div",
                    { staticClass: "btn-box" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { disabled: _vm.formDisabled },
                          on: { click: _vm.resetForm }
                        },
                        [_vm._v("\n            取消\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "37px" },
                          attrs: {
                            type: "primary",
                            disabled: _vm.formDisabled
                          },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("\n            提交\n          ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5471e489", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5471e489","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/companyCertificate/pages/publicInstitutionPerson.vue
// module id = null
// module chunks = 